export default "__VITE_ASSET__0566bb10__"